module.exports = __webpack_public_path__ + "static/media/casino-chips.79d7943c.png";